<template>
  <a-card class="m-display-flex flex-column nowrap">
    <a-form class="margin-bottom" :form="form">
      <a-row :gutter="12">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
          <!-- <a-form-item label="Date">
            <a-date-picker
              placeholder="Select Date"
              :format="getDefaultDateFormat"
              v-decorator="[
                'date',
                {
                  rules: [{ required: true }],
                  initialValue: information ? moment(information[0].date) : moment(),
                },
              ]"
              disabled
            />
          </a-form-item> -->
          <a-form-item label="Sales Notification">
            <a-input
              v-decorator="['sales_notification', { rules: [{ required: true }],
              initialValue: information ? information[0].sales_notification : '' }]"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item label="Code">
            <a-input
              v-decorator="['kode', { rules: [{ required: true }],
              initialValue: information ? information[0].kode : '' }]"
              disabled
            ></a-input>
          </a-form-item>
          
          <a-form-item label="Contract No.">
            <a-input
              v-decorator="['no_sales_contract', { rules: [{ required: true }],
              initialValue: information ? information[0].no_sales_contract : '' }]"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item label="Contract Name">
            <a-textarea
              placeholder="Write the note here ... "
              :rows="2"
              v-decorator="['description', { 
                initialValue : information ? information[0].description : ''}]"
              disabled
            />
          </a-form-item>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
          <a-form-item label="Customer Name">
            <a-select
              v-decorator="[
                'customer_id',
                {
                  rules: [
                    { required: false, message: 'Customer Name Required' },
                  ],
                  initialValue:  information ? information[0].customer_id : '',
                },
              ]"
              disabled
              showSearch
              option-filter-prop="children" :filter-option="filterOption"
            >
              <a-select-option
                v-for="item in customer_list"
                :key="item.customer_id"
                :value="item.customer_id"
                >{{ item.customer_code }} - {{ item.customer_nm }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="SKTD PPN No">
            <a-input
              v-decorator="['sktd_ppn_no', { rules: [{ required: true }],
              initialValue: information ? information[0].sktd_ppn_no :'' }]"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item label="Pimpro">
            <a-select
              placeholder="Select Pimpro"
              allowClear
              disabled
              v-decorator="['pimpro', {rules: [{required: true}], 
              initialValue: information ? information[0].pimpro : undefined}]"
            >
              <a-select-option
              v-for="item in combo_pimpro"
              :key="item.value"
              >{{ item.text }}</a-select-option
            >
            </a-select>
          </a-form-item>
          <a-form-item label="Periode Contract">
            <a-range-picker
              :placeholder="['Start Date', 'End Date']"
              v-decorator="['transactionDt', {rules: [{required: true}],
              initialValue: [information ? moment(information[0].periode_start_dt) : moment()
                , information ? moment(information[0].periode_end_dt) : moment()]
              }]"
              disabled
              :format="getDefaultDateFormat"
            />
          </a-form-item>
          <a-form-item label="Invoice to">
            <a-textarea
              placeholder="Write the text here ... "
              :rows="2"
              v-decorator="['invoice_to',{ initialValue: information ? information[0].invoice_to : ''}]"
              disabled
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button class="padding-remove" type="primary" @click="save"
            >save</a-button
          >
          <a-button type="primary" @click="preview"
            >Preview Account Receiveable</a-button
          >
      </div>
    </template> -->
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";

export default {
  name: "information",
  props: {
    id: String,
    information: {},
    combo_pimpro: {},
    customer_list: {},
  },
  mixins: [CurrencyFormat],
  components: {
  },
  data() {
    return {
      postData: new FormData(),
      push: [],
      listSaleNotif: [
        {
          id: "abc",
          value: "05.01/SN.ITS/AHAW21/02.2021",
        },
        {
          id: "abcd",
          value: "06.01/SN.ITS/DEV21/02.2021",
        },
        {
          id: "abcde",
          value: "07.01/SN.ITS/BYAN21/02.2021",
        }
      ],
      listCode:[
        {id:"ahaw",value:"AHAW"},
        {id:"BYAN",value:"BYAN"},
        {id:"VIOS",value:"VIOS"}
      ],
      listPimpro:[
        {id:"ADI",value:"(ADI) Johanes Adi Sasongko"}
      ]
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getStandartFormatDate","getDefaultDateFormat",]),
  },
  created() {
  },
  methods: {
    moment,
    handleRemove() {
      this.push = [];
    },
    save(){
      this.confirmMessage("confirm-save");
    },
    preview(){

    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let data = {
          description: values.description,
          sktd_ppn_no: values.sktd_ppn_no,
          pimpro: values.pimpro,
          periode_end_dt: moment(values.transactionDt[1]).format(this.getStandartFormatDate),
          periode_start_dt: moment(values.transactionDt[0]).format(this.getStandartFormatDate),
          invoice_to: values.invoice_to,
      }

        Event.$emit("emitChild", {
            informasi: data
        });
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  mounted() {
  },
  beforeDestroy() {
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
};
</script>

<style>
</style>